/* eslint-disable max-classes-per-file */
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  TypedFormModalComponent,
} from '@src/app/components/modals/typed-form-modal/typed-form-modal.component';
import { TypedFormModalDataObject } from '@src/app/model/typed-form-modal-data-object';
import { Observable, of, takeWhile } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { fixedEnvironment } from '@src/environments/environment.fixed';

export class TypedFormModal {
  static openTypedFormModalDialog(
    dialog: MatDialog, data: TypedFormModalDataObject): MatDialogRef<TypedFormModalComponent> {
    return dialog.open(
      TypedFormModalComponent,
      {
        data,
        minWidth: fixedEnvironment.jsonModalWidthLarge,
      }
    );
  }

  static useFormDialog(
    dialogRef: MatDialogRef<TypedFormModalComponent>,
    process: (body: JSON | JSON[]) => Observable<boolean>,
    onFailMsg: string,
    onSuccess: () => void,
    onError: (err: Error) => void = (_) => {
    },
  ): void {
    const processOutputFn = (result: JSON | JSON[]) => process(result);
    let isOpen = true;
    dialogRef.componentInstance.submit
      .pipe(
        takeWhile(() => isOpen),
        switchMap(editedObject =>
          processOutputFn(editedObject).pipe(
            catchError((e) => {
              dialogRef.componentInstance.waitingForResponse = false;
              return of(new TypedFormModalError(e));
            })
          )
        )
      ).subscribe((r) => {
        if (r instanceof TypedFormModalError) {
          onError(r.error);
        } else if (!r) {
          window.alert(onFailMsg);
        } else {
        // on success, close dialog
          onSuccess();
          isOpen = false;
          dialogRef.componentInstance?.closeDialog();
        }
        dialogRef.componentInstance.waitingForResponse = false;
      });
  }
}

class TypedFormModalError {
  constructor(public error: Error) {
  }
}
/* eslint-enable max-classes-per-file */
